export type IconName =
  | "house"
  | "calendar"
  | "download"
  | "cloud"
  | "sync"
  | "globe"
  | "doc"
  | "gear"
  | "signout"
  | "book"
  | "check"
  | "alert"
  | "tray";

const PATHS: Record<IconName, string> = {
  house: "M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5M9.5 20v-6h5v6",
  calendar:
    "M7 4.5v2M17 4.5v2M4.5 8.5h15M5.5 6.5h13A1.5 1.5 0 0 1 20 8v11a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19V8a1.5 1.5 0 0 1 1.5-1.5Z",
  download: "M12 4.5v10M8 11l4 3.5 4-3.5M5 19.5h14",
  cloud:
    "M7.5 17.5h9.2A3.8 3.8 0 0 0 20 12.8a3.7 3.7 0 0 0-3.2-3.6A5 5 0 0 0 7.2 10.5 3.5 3.5 0 0 0 7.5 17.5Z",
  sync: "M4.5 12a7.5 7.5 0 0 1 12.8-5.3M19.5 12a7.5 7.5 0 0 1-12.8 5.3M17 3.5v3.5h-3.5M7 20.5V17h3.5",
  globe:
    "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM4.5 12h15M12 4c2.5 2.8 2.5 9.2 0 12M12 4c-2.5 2.8-2.5 9.2 0 12",
  doc: "M7 4.5h6.5L17.5 9v10.5H7V4.5ZM13.5 4.5V9h4",
  gear: "M12 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6ZM12 4.5v2M12 17.5v2M4.5 12h2M17.5 12h2M6.4 6.4l1.4 1.4M16.2 16.2l1.4 1.4M17.6 6.4l-1.4 1.4M7.8 16.2l-1.4 1.4",
  signout:
    "M14 4.5H6.5A1.5 1.5 0 0 0 5 6v12a1.5 1.5 0 0 0 1.5 1.5H14M16 8.5l3.5 3.5L16 15.5M11 12h8.5",
  book: "M5 5.5A2 2 0 0 1 7 3.5h11.5v15H7a2 2 0 0 0-2 2v-15ZM7 3.5v15",
  check: "M5 12.5 9.5 17 19 7.5",
  alert: "M12 4.5 21 19.5H3L12 4.5ZM12 10v4.5M12 16.8v.2",
  tray: "M4 13.5 6.5 6h11L20 13.5M4 13.5V18a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 18v-4.5M4 13.5h4l1 2h6l1-2h4",
};

export function Icon({
  name,
  size = 18,
  strokeWidth = 1.7,
}: {
  name: IconName;
  size?: number;
  strokeWidth?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
